/**
 * Include your custom JavaScript here.
 * (Theme hooks: 'variant:changed', 'product:added', 'cart:refresh' - see Warehouse docs.)
 */

/* Big Papa - collapse long collection descriptions with a "Read more" toggle (draft theme 188236497110) */
(function () {
  function init() {
    var fr = (document.documentElement.lang || '').indexOf('fr') === 0;
    var more = fr ? 'Lire la suite' : 'Read more';
    var less = fr ? 'Voir moins' : 'Show less';
    var descs = document.querySelectorAll('.collection__description');
    if (!descs.length) return;
    var st = document.createElement('style');
    st.textContent = '.bp-desc-collapsed{max-height:170px;overflow:hidden;position:relative}' +
      '.bp-desc-collapsed:after{content:"";position:absolute;left:0;right:0;bottom:0;height:70px;background:linear-gradient(rgba(255,255,255,0),#fff)}' +
      '.bp-desc-toggle{margin-top:10px;background:none;border:0;padding:0;color:#1F5FBF;font-weight:600;cursor:pointer;text-decoration:underline}';
    document.head.appendChild(st);
    descs.forEach(function (d) {
      if (d.dataset.bpCollapse || d.scrollHeight < 260) return;
      d.dataset.bpCollapse = '1';
      d.classList.add('bp-desc-collapsed');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bp-desc-toggle';
      b.textContent = more;
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        var open = d.classList.toggle('bp-desc-collapsed') === false;
        b.textContent = open ? less : more;
        b.setAttribute('aria-expanded', String(open));
      });
      d.parentNode.insertBefore(b, d.nextSibling);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* Big Papa - Google Ads conversion: Clic WhatsApp */ document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"]'); if (a && typeof window.gtag === 'function') { window.gtag('event', 'conversion', { 'send_to': 'AW-16791612353/8wJ7CKSxwpcdEMHX7sY-' }); } }, true);
/* Big Papa - search bar category dropdown: opens the category right away */ document.addEventListener('change', function (e) { var s = e.target; if (!s || s.id !== 'search-product-type' || !s.value) return; var input = s.form && s.form.querySelector('.search-bar__input'); if (input && input.value.trim() !== '') return; var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; window.location.href = root + 'collections/types?q=' + encodeURIComponent(s.value); });
/* Big Papa - old Canada addresses (/fr-ca/, /en-ca/) now live on the main domain: send visitors to the new address */ (function () { var m = location.pathname.match(/^\/(fr|en)-ca(\/.*)?$/); if (m) { location.replace((m[1] === 'en' ? '/en' : '') + (m[2] || '/') + location.search + location.hash); } })();